/* Registrations.js */

"use strict";
module.exports = {
    ROBO_HELP_SECTION: "App.GameConsole.Section.RoboHelp",
};
Object.freeze(module.exports);
